import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';


import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

import { PagesModule } from './pages/pages.module';
import { SharedModule } from './shared/shared.module';
import { SwiperModule } from 'swiper/angular';
import { NgxLoadingModule } from 'ngx-loading';

import { services } from '@app/core/services';
import { of } from 'rxjs';

// 告訴 ngx-translate 如何載入翻譯檔
// export function HttpLoaderFactory(http: HttpClient) {
// 	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }

export class TranslateFsLoader implements TranslateLoader {
	constructor(private prefix: string = './assets/i18n', private suffix: string = '.json') {}

	getTranslation(lang: string) {
		const fs = eval('require("fs")');
		const path = eval('require("path")');
		const processCwd = eval('process').cwd();

		try {
			const filePath = path.join(
				processCwd,
			'dist/kunyou-website/browser',
			this.prefix,
			`${lang}${this.suffix}`,
		);
			const data = fs.readFileSync(filePath, 'utf8');
			return of(JSON.parse(data));
		} catch (err) {
			console.error(`SSR 讀取語系檔失敗: ${lang}`, err);
			return of({});
		}
	}
}

export function TranslateLoaderFactory(http: HttpClient, platformId: Object): TranslateLoader {
	if (isPlatformServer(platformId)) {
	  // SSR / Prerender 使用 FS Loader
		return new TranslateFsLoader('./assets/i18n', '.json');
	}
	// 瀏覽器使用 HTTP Loader
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserAnimationsModule,
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		FormsModule,
		HttpClientModule,
		RouterModule,
		AppRoutingModule,
		PagesModule,
		SharedModule,
		SwiperModule,
		NgxLoadingModule,
		// 設定語系：預設中文，使用 HTTP 載入翻譯檔案
		TranslateModule.forRoot({
			defaultLanguage: 'zh-tw',
			loader: {
				provide: TranslateLoader,
				useFactory: TranslateLoaderFactory,
				deps: [HttpClient, PLATFORM_ID]
			}
		})
	],
	providers: [...services],
	bootstrap: [AppComponent],
})
export class AppModule {}
